import { 
  useEntities, 
  useEntity, 
  useCreateEntity, 
  useUpdateEntity, 
  useDeleteEntity 
} from './useSWR';

// ============================================================================
// CONVENIENCE HOOKS - Simple wrappers for common entities
// ============================================================================

// Users
export const useUsers = (params) => useEntities('/users', params);
export const useUser = (id) => useEntity('/users', id);
export const useCreateUser = () => useCreateEntity('/users');
export const useUpdateUser = () => useUpdateEntity('/users');
export const useDeleteUser = () => useDeleteEntity('/users');

// Departments  
export const useDepartments = (params) => useEntities('/department', params);
export const useDepartment = (id) => useEntity('/department', id);
export const useCreateDepartment = () => useCreateEntity('/department');
export const useUpdateDepartment = (id) => useUpdateEntity('/department', id);
export const useDeleteDepartment = () => useDeleteEntity('/department');

// Documents (Document Management)
export const useDocuments = (params) => useEntities('/document-management/document', params);
export const useDocument = (id) => useEntity('/document-management/document', id);
export const useCreateDocument = () => useCreateEntity('/document-management/document');
export const useUpdateDocument = () => useUpdateEntity('/document-management/document');
export const useDeleteDocument = () => useDeleteEntity('/document-management/document');

// Document Types
export const useDocumentTypes = (params) => useEntities('/document-type', params);
export const useDocumentType = (id) => useEntity('/document-type', id);
export const useCreateDocumentType = () => useCreateEntity('/document-type');
export const useUpdateDocumentType = () => useUpdateEntity('/document-type');
export const useDeleteDocumentType = () => useDeleteEntity('/document-type');

// CAPAs
export const useCapas = (params) => useEntities('/capa', params);
export const useCapa = (id) => useEntity('/capa', id);
export const useCreateCapa = () => useCreateEntity('/capa');
export const useUpdateCapa = () => useUpdateEntity('/capa');
export const useDeleteCapa = () => useDeleteEntity('/capa');

// Risk Assessments
export const useRiskAssessments = (params) => useEntities('/risk-assessment', params);
export const useRiskAssessment = (id) => useEntity('/risk-assessment', id);
export const useCreateRiskAssessment = () => useCreateEntity('/risk-assessment');
export const useUpdateRiskAssessment = () => useUpdateEntity('/risk-assessment');
export const useDeleteRiskAssessment = () => useDeleteEntity('/risk-assessment');

// Non-Conformity Reports
export const useNonConformityReports = (params) => useEntities('/non-conformity-report', params);
export const useNonConformityReport = (id) => useEntity('/non-conformity-report', id);
export const useCreateNonConformityReport = () => useCreateEntity('/non-conformity-report');
export const useUpdateNonConformityReport = () => useUpdateEntity('/non-conformity-report');
export const useDeleteNonConformityReport = () => useDeleteEntity('/non-conformity-report');

// Complaints
export const useComplaints = (params) => useEntities('/complaint', params);
export const useComplaint = (id) => useEntity('/complaint', id);
export const useCreateComplaint = () => useCreateEntity('/complaint');
export const useUpdateComplaint = () => useUpdateEntity('/complaint');
export const useDeleteComplaint = () => useDeleteEntity('/complaint');

// Deviations
export const useDeviations = (params) => useEntities('/deviation', params);
export const useDeviation = (id) => useEntity('/deviation', id);
export const useCreateDeviation = () => useCreateEntity('/deviation');
export const useUpdateDeviation = () => useUpdateEntity('/deviation');
export const useDeleteDeviation = () => useDeleteEntity('/deviation');

// Approval Requests
export const useApprovalRequests = (params) => useEntities('/approval-requests', params);
export const useApprovalRequest = (id) => useEntity('/approval-requests', id);
export const useCreateApprovalRequest = () => useCreateEntity('/approval-requests');
export const useUpdateApprovalRequest = () => useUpdateEntity('/approval-requests');
export const useDeleteApprovalRequest = () => useDeleteEntity('/approval-requests');

// Suppliers
export const useSuppliers = (params) => useEntities('/supplier', params);
export const useSupplier = (id) => useEntity('/supplier', id);
export const useCreateSupplier = () => useCreateEntity('/supplier');
export const useUpdateSupplier = () => useUpdateEntity('/supplier');
export const useDeleteSupplier = () => useDeleteEntity('/supplier');

// Training
export const useTrainingAssignments = (params) => useEntities('/training-assignment', params);
export const useTrainingAssignment = (id) => useEntity('/training-assignment', id);
export const useCreateTrainingAssignment = () => useCreateEntity('/training-assignment');
export const useUpdateTrainingAssignment = () => useUpdateEntity('/training-assignment');
export const useDeleteTrainingAssignment = () => useDeleteEntity('/training-assignment');

// Employees
export const useEmployees = (params) => useEntities('/employee', params);
export const useEmployee = (id) => useEntity('/employee', id);
export const useCreateEmployee = () => useCreateEntity('/employee');
export const useUpdateEmployee = () => useUpdateEntity('/employee');
export const useDeleteEmployee = () => useDeleteEntity('/employee');

// Trainings
export const useTrainings = (params) => useEntities('/training', params);
export const useTraining = (id) => useEntity('/training', id);
export const useCreateTraining = () => useCreateEntity('/training');
export const useUpdateTraining = () => useUpdateEntity('/training');
export const useDeleteTraining = () => useDeleteEntity('/training');

// Change Requests
export const useChangeRequests = (params) => useEntities('/change-request', params);
export const useChangeRequest = (id) => useEntity('/change-request', id);
export const useCreateChangeRequest = () => useCreateEntity('/change-request');
export const useUpdateChangeRequest = () => useUpdateEntity('/change-request');
export const useDeleteChangeRequest = () => useDeleteEntity('/change-request');

// Supplier Ratings
export const useSupplierRatings = (params) => useEntities('/supplier-rating', params);
export const useSupplierRating = (id) => useEntity('/supplier-rating', id);
export const useCreateSupplierRating = () => useCreateEntity('/supplier-rating');
export const useUpdateSupplierRating = () => useUpdateEntity('/supplier-rating');
export const useDeleteSupplierRating = () => useDeleteEntity('/supplier-rating');

// Ticketing requests (Prisma: TicketingRequest)
export const useTicketingRequests = (params) => useEntities('/ticketing/requests', params);

// External audits (Prisma: ExternalAudit)
export const useExternalAudits = (params) => useEntities('/external-audit', params);

// Todos (CRM)
export const useTodos = (params) => useEntities('/todo', params);
export const useTodo = (id) => useEntity('/todo', id);
export const useCreateTodo = () => useCreateEntity('/todo');
export const useUpdateTodo = () => useUpdateEntity('/todo');
export const useDeleteTodo = () => useDeleteEntity('/todo');

// Product Status Change
export const useProductStatusChanges = (params) =>
  useEntities('/product-status-change', params);

// Manuals (IT)
export const useManuals = (params) => useEntities('/manual', params);

// Contracts
export const useContracts = (params) => useEntities('/contract', params);

// Admin/Lookup Data
export const useRoles = (params) => useEntities('/role', params);
export const usePriorities = (params) => useEntities('/priority', params);
export const useRiskLevels = (params) => useEntities('/risk-level', params);
export const useEntityTypes = (params) => useEntities('/entity-type', params);

// ============================================================================
// EXAMPLES OF HOW TO USE
// ============================================================================

/*

// GET ALL USERS
const { data: users, isLoading, error } = useUsers();

// GET USER BY ID  
const { data: user } = useUser(123);

// CREATE USER
const { create: createUser, isLoading: creating } = useCreateUser();
const handleCreate = () => {
  createUser(userData, ['id', 'createdAt', 'updatedAt']); // fieldsToRemove
};

// UPDATE USER
const { update: updateUser } = useUpdateUser(123);
const handleUpdate = () => {
  updateUser(userData, ['id', 'fullName', 'displayName']);
};

// DELETE USER
const { delete: deleteUser } = useDeleteUser();
const handleDelete = () => {
  deleteUser(123);
};

// FOR ANY OTHER ENTITY (use generic hooks directly):
const { data: customEntities } = useEntities('/custom-endpoint');
const { data: customEntity } = useEntity('/custom-endpoint', 456);
const { create: createCustom } = useCreateEntity('/custom-endpoint');

*/
